const DEFAULT_PRINT_DELAY_MS = 0;

const normalizeFilename = (value) => {
  if (value == null) return '';
  const raw = String(value).trim();
  if (!raw || raw === '—') return '';
  return raw.replace(/[\\/:*?"<>|]/g, '-');
};

export const printWithFilename = (filename, options = {}) => {
  const { delayMs = DEFAULT_PRINT_DELAY_MS } = options;
  const nextTitle = normalizeFilename(filename);
  const originalTitle = document.title;

  const runPrint = () => {
    if (nextTitle) document.title = nextTitle;

    let restored = false;
    const restoreTitle = () => {
      if (restored) return;
      restored = true;
      document.title = originalTitle;
      window.removeEventListener('afterprint', restoreTitle);
    };

    window.addEventListener('afterprint', restoreTitle);
    window.print();
    setTimeout(restoreTitle, 1000);
  };

  if (delayMs > 0) {
    setTimeout(runPrint, delayMs);
    return;
  }
  runPrint();
};
